import { __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import ScreenReaderOnlyText from '../../helpers/ScreenReaderOnlyText';
import styles from './ToggleSwitch.module.scss';
const ToggleSwitch = (_a) => {
    var { id, checked, disabled, onChange, onKeyDown, className, label, isInputBlack = false } = _a, props = __rest(_a, ["id", "checked", "disabled", "onChange", "onKeyDown", "className", "label", "isInputBlack"]);
    return (React.createElement("label", Object.assign({ className: cn(styles.switch, className), htmlFor: id }, props),
        React.createElement("input", { type: "checkbox", id: id, checked: checked, onChange: onChange, onKeyDown: onKeyDown, disabled: disabled, className: cn(isInputBlack && styles.inputBlack) }),
        React.createElement("span", { className: styles.knob }),
        label && React.createElement(ScreenReaderOnlyText, null, label)));
};
export default ToggleSwitch;
//# sourceMappingURL=ToggleSwitch.js.map